import Client from '@/client'

export default {
  list(offset, limit=20) {
    let query = `{id,uuid,name,completion{name},production{name},economic{name},owner{id,name},shape,status,updated_at}`;
    return Client.get(`datasets/`, { params: { limit: limit, offset: offset, query: query }});
  },
  create(payload) {
    return Client.post(`datasets/`, payload)
  },
  retrieve(id) {
    return Client.get(`datasets/${id}/`)
  },
  head(id, size=50) {
    return Client.get(`datasets/${id}/head/`, { params: { size: size } } )
  },
  info(id) {
    return Client.get(`datasets/${id}/info/`)
  },
  stats(id, column) { 
    return Client.get(`datasets/${id}/stats`, { params: { column: column }})
  },
  columns(id) {
    return Client.get(`datasets/${id}/columns/`)
  },
  update(id, payload) {
    return Client.put(`datasets/${id}/`, payload)
  },
  refresh(id, payload) {
    return Client.put(`datasets/${id}/refresh/`, payload)
  },
  share(id, payload) {
    return Client.post(`datasets/${id}/share/`, payload)
  },
  clone(id, payload) {
    return Client.post(`datasets/${id}/clone/`, payload)
  },
  apis(id) {
    return Client.get(`datasets/${id}/apis/`)
  },
  patch(id, payload) {
    return Client.patch(`datasets/${id}/`, payload)
  },
  destroy(id) {
    return Client.delete(`datasets/${id}/`)
  },
  delete(payload) {
    return Client.post('datasets/delete/', payload)
  }
}